const scroll = window.requestAnimationFrame || function(callback){ window.setTimeout(callback, 1000/60)};
const scrollOffset = 100;
  
function loop() {
  const elementsToShow = document.querySelectorAll('.js-animate'); 
  
  elementsToShow.forEach( el => {
    if ( el.getAttribute('data-delay') ) {
      el.style.transitionDelay = el.getAttribute('data-delay') + 'ms'
    }
    if ( el.getAttribute('data-duration') ) {
      el.style.transitionDuration = el.getAttribute('data-duration') + 'ms'
    }
  })

  Array.prototype.forEach.call(elementsToShow, function(element){
      
    if (isElementInViewport(element)) {
      element.classList.add('animated');
    }
    
  });
}

  
function isElementInViewport(el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();
  const top = rect.top + scrollOffset
  const bottom = rect.bottom
  return (
    (top <= 0 && bottom >= 0)
    ||
    (bottom >= (window.innerHeight || document.documentElement.clientHeight) 
    &&
    top <= (window.innerHeight || document.documentElement.clientHeight))
    ||
    (top >= 0 && bottom <= (window.innerHeight || document.documentElement.clientHeight))
  );
}

setTimeout(() => {
  loop()
  window.addEventListener('scroll', () => loop())
  window.addEventListener('resize', () => loop())
}, 300)